import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import Badge from '@/components/common/Badge';
import { Card } from '@/components/common/Card';
import CardContent from '@/components/common/Card/CardContent';
import CardHeader from '@/components/common/Card/CardHeader';
import CardTitle from '@/components/common/Card/CardTitle';
import type { GroupListItemDataFragment, SubgroupListItemDataFragment } from '@/gql/graphql';

interface ViewCourseProps {
    group?: GroupListItemDataFragment;
    subgroup?: SubgroupListItemDataFragment;
}

const ViewCourse = ({ group, subgroup }: ViewCourseProps) => {
    const { t } = useTranslation('groupDetails');

    const courses = useMemo(() => group?.enrolledCourses ?? [], [group?.enrolledCourses]);

    return (
        <Card>
            <CardHeader className="pb-2">
                <CardTitle className="text-lg">
                    {subgroup
                        ? t('fields.courses.titleSubgroup', { parentGroupName: group?.name })
                        : t('fields.courses.titleGroup')}
                </CardTitle>
            </CardHeader>
            <CardContent className="space-y-2 pt-0">
                {courses.length > 0 ? (
                    <div className="flex flex-wrap gap-2">
                        {courses.map(course => (
                            <Badge key={course.id} color="teal" text={course.name} />
                        ))}
                    </div>
                ) : (
                    <p className="text-muted-foreground text-sm">{t('fields.courses.error')}</p>
                )}
                {subgroup && <p className="text-muted-foreground text-xs italic">{t('fields.courses.footer')}</p>}
            </CardContent>
        </Card>
    );
};

export default ViewCourse;
